import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NotFound from './pages/NotFound';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import CreateProduct from './pages/CreateProduct';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Signup from './pages/Signup';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ForgotEmail from './pages/ForgotEmail';
import RefundPolicy from './pages/RefundPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Imprint from './pages/Imprint';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import Checkout from './pages/Checkout';
import Comparison from './pages/Comparison';
import UserProfile from './pages/UserProfile';
import UserOrders from './pages/UserOrders';
import OrderDetails from './pages/OrderDetails';
import ProductAdmin from './features/admin/ProductAdmin';
import EditProduct from './pages/EditProduct';
import MessagesAdmin from './features/admin/MessagesAdmin';
import ReviewsAdmin from './features/admin/ReviewsAdmin';
import FeedbackAdmin from './features/admin/FeedbackAdmin';
import Admin from './features/admin/Admin';
import AdminUsers from './features/admin/AdminUsers';
import AdminAnalytics from './features/admin/AdminAnalytics';
import HeroAdmin from './features/admin/HeroAdmin';
import CategoryAdmin from './features/admin/CategoryAdmin';
import AboutAdmin from './features/admin/AboutAdmin';
import ProtectedRoute from './components/common/ProtectedRoute';
import ScrollToTop from './components/common/ScrollToTop';
import { CurrencyProvider } from './context/CurrencyContext';
import { UploadProvider } from './context/UploadContext';
import { BrandingProvider } from './context/BrandingContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { HelmetProvider } from 'react-helmet-async';
import AdminLogs from './features/admin/AdminLogs';
import AdminProfile from './features/admin/AdminProfile';
import ContactInfoAdmin from './features/admin/ContactInfoAdmin';
import TrashAdmin from './features/admin/TrashAdmin';
import AdminSecrets from './features/admin/AdminSecrets';
import SystemSettingsAdmin from './features/admin/SystemSettingsAdmin';
import TasksAdmin from './features/admin/TasksAdmin';
import LegalAdmin from './features/admin/LegalAdmin';
import WhatsAppAdmin from './features/admin/WhatsAppAdmin';
import AIAdmin from './features/admin/AIAdmin';
import MagicWriterAdmin from './features/admin/MagicWriterAdmin';
import InstructionsAdmin from './features/admin/InstructionsAdmin';
import OrdersAdmin from './features/admin/OrdersAdmin';
import WishlistAdmin from './features/admin/WishlistAdmin';
import CartAdmin from './features/admin/CartAdmin';
import ContractAdmin from './features/admin/ContractAdmin';
import BreachReportAdmin from './features/admin/BreachReportAdmin';
import DataSubjectRightsAdmin from './features/admin/DataSubjectRightsAdmin';
import CommunicationChannel from './features/admin/CommunicationChannel';
import ChannelWizard from './features/communication/ChannelWizard';
import GlobalConsentBanner from './components/common/GlobalConsentBanner';
import Stories from './pages/Stories';
// Import new components
// import BuyerInfo from './pages/BuyerInfo';
// import ContractPage from './pages/ContractPage';
function App() {
  return (
    <HelmetProvider>
      <BrandingProvider>
        <UploadProvider>
          <CartProvider>
            <WishlistProvider>
              <CurrencyProvider>
                <ScrollToTop />
                <GlobalConsentBanner />
                <Routes>
                  <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="shop" element={<Shop />} />
                    <Route path="shop/:id" element={<ProductDetail />} />
                    <Route path="cart" element={<Cart />} />
                    <Route path="wishlist" element={<Wishlist />} />
                    <Route path="checkout" element={<Checkout />} />
                    <Route path="compare" element={<Comparison />} />

                    {/* User Portal */}
                    <Route path="profile" element={<ProtectedRoute requireAdmin={false}><UserProfile /></ProtectedRoute>} />
                    <Route path="profile/orders" element={<ProtectedRoute requireAdmin={false}><UserOrders /></ProtectedRoute>} />
                    <Route path="profile/orders/:id" element={<ProtectedRoute requireAdmin={false}><OrderDetails /></ProtectedRoute>} />
                    {/* Admin Routes */}
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/admin/logs" element={<ProtectedRoute permission="*"><AdminLogs /></ProtectedRoute>} />
                    <Route path="/admin/messages" element={<ProtectedRoute permission="messages"><MessagesAdmin /></ProtectedRoute>} />
                    <Route path="/admin/contact-info" element={<ProtectedRoute permission="*"><ContactInfoAdmin /></ProtectedRoute>} />
                    <Route path="/admin/profile" element={<ProtectedRoute><AdminProfile /></ProtectedRoute>} />
                    <Route path="/admin/analytics" element={<ProtectedRoute permission="analytics"><AdminAnalytics /></ProtectedRoute>} />
                    <Route path="/admin/users" element={<ProtectedRoute permission="users"><AdminUsers /></ProtectedRoute>} />
                    <Route path="/admin/product" element={<ProtectedRoute permission="products"><ProductAdmin /></ProtectedRoute>} />
                    <Route path="/admin/edit-product/:id" element={<ProtectedRoute permission="products"><EditProduct /></ProtectedRoute>} />
                    <Route path="/admin/create-product" element={<ProtectedRoute permission="products"><CreateProduct /></ProtectedRoute>} />
                    <Route path="/admin/reviews" element={<ProtectedRoute permission="reviews"><ReviewsAdmin /></ProtectedRoute>} />
                    <Route path="/admin/feedback" element={<ProtectedRoute permission="feedback"><FeedbackAdmin /></ProtectedRoute>} />
                    <Route path="/admin/hero" element={<ProtectedRoute permission="hero"><HeroAdmin /></ProtectedRoute>} />
                    <Route path="/admin/categories" element={<ProtectedRoute permission="categories"><CategoryAdmin /></ProtectedRoute>} />
                    <Route path="/admin/about" element={<ProtectedRoute permission="about"><AboutAdmin /></ProtectedRoute>} />
                    <Route path="/admin/trash" element={<ProtectedRoute permission="*"><TrashAdmin /></ProtectedRoute>} />
                    <Route path="/admin/secrets" element={<ProtectedRoute permission="*"><AdminSecrets /></ProtectedRoute>} />
                    <Route path="/admin/settings" element={<ProtectedRoute permission="*"><SystemSettingsAdmin /></ProtectedRoute>} />
                    <Route path="/admin/tasks" element={<ProtectedRoute permission="*"><TasksAdmin /></ProtectedRoute>} />
                    <Route path="/admin/legal" element={<ProtectedRoute permission="*"><LegalAdmin /></ProtectedRoute>} />
                    <Route path="/admin/whatsapp" element={<ProtectedRoute permission="*"><WhatsAppAdmin /></ProtectedRoute>} />
                    <Route path="/admin/ai" element={<ProtectedRoute permission="*"><AIAdmin /></ProtectedRoute>} />
                    <Route path="/admin/magic-writer" element={<ProtectedRoute permission="*"><MagicWriterAdmin /></ProtectedRoute>} />
                    <Route path="/admin/instructions" element={<ProtectedRoute permission="*"><InstructionsAdmin /></ProtectedRoute>} />
                    <Route path="/admin/orders" element={<ProtectedRoute permission="*"><OrdersAdmin /></ProtectedRoute>} />
                    <Route path="/admin/wishlist-insights" element={<ProtectedRoute permission="*"><WishlistAdmin /></ProtectedRoute>} />
                    <Route path="/admin/cart-insights" element={<ProtectedRoute permission="*"><CartAdmin /></ProtectedRoute>} />
                    <Route path="/admin/contracts" element={<ProtectedRoute permission="*"><ContractAdmin /></ProtectedRoute>} />
                    <Route path="/admin/compliance/breaches" element={<ProtectedRoute permission="*"><BreachReportAdmin /></ProtectedRoute>} />
                    <Route path="/admin/compliance/data-subject" element={<ProtectedRoute permission="*"><DataSubjectRightsAdmin /></ProtectedRoute>} />
                    <Route path="/admin/compliance/communication-channel" element={<ProtectedRoute permission="*"><CommunicationChannel /></ProtectedRoute>} />
                    <Route path="/admin/channel-wizard" element={<ProtectedRoute permission="*"><ChannelWizard /></ProtectedRoute>} />

                    {/* Public Pages */}
                    <Route path="stories" element={<Stories />} />
                    <Route path="about" element={<About />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="terms" element={<Terms />} />
                    <Route path="refund-policy" element={<RefundPolicy />} />
                    <Route path="shipping-policy" element={<ShippingPolicy />} />
                    <Route path="cookies" element={<CookiePolicy />} />
                    <Route path="imprint" element={<Imprint />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/forgot-email" element={<ForgotEmail />} />
                    <Route path="*" element={<NotFound />} />

                    {/* New pages */}
                    {/* <Route path="/buyer-info" element={<BuyerInfo />} /> */}
                    {/* <Route path="/contract" element={<ContractPage />} /> */}

                  </Route>
                </Routes>
              </CurrencyProvider>
            </WishlistProvider>
          </CartProvider>
        </UploadProvider>
      </BrandingProvider>
    </HelmetProvider>
  );
}
export default App;